module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_7005.9be2b4e8.png";